var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.debug)?_c('div',[_vm._v(" mData:"+_vm._s(_vm.mData)+" "),_c('hr'),_vm._v(" getLegendData:"+_vm._s(_vm.getLegendData)+" ")]):_vm._e(),_c('div',{ref:"echartComp",staticStyle:{"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }